import { render, staticRenderFns } from "./GeneralApplyList.vue?vue&type=template&id=f5f59e52"
import script from "./GeneralApplyList.vue?vue&type=script&lang=ts"
export * from "./GeneralApplyList.vue?vue&type=script&lang=ts"
import style0 from "./GeneralApplyList.vue?vue&type=style&index=0&id=f5f59e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports